import React, { useEffect } from 'react'
import { ShareWorkoutCardContainer } from './styles'
import PropTypes from "prop-types";
import { Border } from '../SocialFeedsV2/styles';

const ShareWorkoutCard = ({workoutName, workoutData}) => {

  useEffect(()=>{
    // window.console.log("HI")
  },[])

  return (
    <ShareWorkoutCardContainer>
      <div className='title'>Crushed my workout! 🎉</div>
      <div className='sub-title'>{workoutName || workoutData?.name} | Workout Completed</div>
      <Border style={{marginBottom:"0px", background:"#EFEFEF"}}/>
      <div className='workout-container'>
        <div className='workout-card'>
          <div className='name'>Active Time</div>
          <div className='activity-log'>{workoutData?.time}</div>
        </div>

        <div className='workout-card'>
          <div className='name'>Workout Intensity</div>
          <div className='activity-log'>{workoutData?.intensity}</div>
        </div>

        <div className='workout-card'>
          <div className='name'>Points Earned</div>
          <div className='activity-log'>{workoutData?.points}</div>
        </div>

      </div>

    </ShareWorkoutCardContainer>
  )
}

ShareWorkoutCard.propTypes = {
  workoutName: PropTypes.string,
  workoutData:PropTypes.string
}

export default ShareWorkoutCard